module.exports = __webpack_public_path__ + "static/media/home-icon.20b4428c.svg";